import { claimsAreSuperUser } from '@shared';
import { useAuth, useCurrentUser } from '../contexts/auth';
import { getClaims } from '../lib/token';

export function useMe() {
  const user = useCurrentUser();
  const claims = getClaims();

  return {
    me: user,
    isSuperUser: claims ? claimsAreSuperUser(claims) : false,
    displayName: [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email,
  };
}

export function useMeOptional() {
  const { user, isLoading } = useAuth();
  const claims = getClaims();

  return {
    me: user,
    isLoading,
    isSuperUser: claims ? claimsAreSuperUser(claims) : false,
  };
}
